import { useCpmsBoGetEnergyDeliveredByThirdPartyEndpointQuery } from '@service/cpms-bo-transaction-reports-energy-statistics.service';

import {
  ByThirdPartyEndpointCard,
  ByThirdPartyEndpointCardVariantEnum,
} from '../../components/by-third-party-endpoint-card/by-third-party-endpoint.card';
import { useFilters } from '../../context/filters.context';

export const EnergyByThirdPartyEndpointCard = (): React.JSX.Element => {
  const { transformedFilters } = useFilters();
  const { data } = useCpmsBoGetEnergyDeliveredByThirdPartyEndpointQuery({
    ...transformedFilters,
  });

  return (
    <ByThirdPartyEndpointCard
      data={data}
      variant={ByThirdPartyEndpointCardVariantEnum.Energy}
    />
  );
};
